module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA6ElEQVR4nO3aTUoDQRSF0cZZsoMqsiSn9RZQD9xG9uAPcZXqRKct7VykepAUeA5kA5fkNfSXZQEAAAAAAADgdu7Lw7GVfInSP6Lm6pO/b1DyPUp/bqd2GB66lf5q3Bz6gm2bDY18Xs53UfLL0Dn4S+6f23aGrpMN7XTkvqFLXsZv9Kkdovann0PvYbj+cZvfWs3HXQ9DAAAAAIB/TpzNkRf+4mxcMVqIs/VaY4uz65RDb/yvI8XZmCwWi7MAAAAAAPuJsynOxgQv+8XZesuxxdl1yqE34myKszHBPRZnAQAAAAAAAJb5fAP1VPDKcya0jAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu.png
// module id = F3CK
// module chunks = 11